import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("rmd_token")) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("rmd_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signIn = (token, u) => {
    localStorage.setItem("rmd_token", token);
    setUser(u);
  };
  const signOut = () => {
    localStorage.removeItem("rmd_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, signIn, signOut, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const homeFor = (u) =>
  !u ? "/" : u.role === "admin" || u.role === "moderator" ? "/admin" : u.role === "companion" ? "/companion" : "/dashboard";
